import React, { useState } from "react";
import styles from "./PriceChart.module.scss";
import {
  Area,
  LineChart,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  YAxis,
  XAxis,
  Legend,
  Line,
} from "recharts";


// import CustomTooltip from '../CustomTooltip/CustomTooltip';

const PriceChart = ({ defaultCurrency, walletData, activeCoinIndex, fill }) => {
  const [chartDataIndex, setChartDataIndex] = useState(0);
  const [activeTab, setActiveTab] = useState(1);
  const renderChange = () => {
    // @ts-ignore
    if (walletData[activeCoinIndex]?.changePercentage24h >= 0) {
      return changePositive;
    } else {
      return changeNegative;
    }
  };
  const data = [
    {
      name: "Page A",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "Page B",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "Page C",
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "Page D",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "Page E",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "Page F",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
    {
      name: "Page G",
      uv: 3490,
      pv: 4300,
      amt: 2100,
    },
  ];
  const handleActiveTab = (tab) => {
    setActiveTab(tab);
  };
  return (
    <>
      <div className={styles.bottomHeader}>
        <div
          className={`${styles.tab} ${activeTab === 1 && styles.activeTab}`}
          onClick={() => handleActiveTab(1)}
        >
          Information
        </div>
        <div
          className={`${styles.tab} ${activeTab === 2 && styles.activeTab}`}
          onClick={() => handleActiveTab(2)}
        >
          Transactions
        </div>
      </div>
      {activeTab === 1 && (
        <>
          <div className={styles.priceChart}>
            {/* MAIN CHART START */}
            <div className={styles.chartHeader}>
              <div className={styles.chartContent}>
                <div className={styles.chartAssetInfo}>
                  <div className={styles.leftWrapper}>
                    <img
                      src={"/assets/bitcoin-btc-logo.svg"}
                      width="25px"
                      height="25px"
                      alt="Picture of the author"
                    />
                  </div>
                  <div className={styles.chartAsset}>
                    <div className={styles.chartAssetShort}>BTC</div>
                    <div className={styles.chartAssetName}>Bitcoin</div>
                  </div>
                </div>
                <div className={styles.chartAssetChangeRow}>
                  <img
                    src={"/assets/polygon.svg"}
                    width="10px"
                    height="7px"
                    alt="Picture of the author"
                  />
                  <div className={styles.changePositive}>+5.07%</div>
                </div>
              </div>
              <div className={styles.chartHeader}>$31,000</div>
            </div>
            <div className={styles.chart}>
              <ResponsiveContainer width="100%" height={180}>
                <AreaChart width={"100%"} height={400} data={data}>
                  <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#f7931a" stopOpacity={0.5} />
                      <stop offset="95%" stopColor="#f7931a" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <Tooltip />
                  <Area
                    type="monotone"
                    dataKey="uv"
                    fillOpacity={1}
                    stroke="#f7931a"
                    fill="url(#colorUv)"
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
            {/* MAIN CHART END */}
            <div className={styles.chartFilters}>
              <div
                onClick={() => {
                  setChartDataIndex(0);
                }}
                className={
                  chartDataIndex === 0 ? styles.filterActive : styles.filter
                }
              >
                24H
              </div>
              <div
                onClick={() => {
                  setChartDataIndex(1);
                }}
                className={
                  chartDataIndex === 1 ? styles.filterActive : styles.filter
                }
              >
                7D
              </div>
              <div
                onClick={() => {
                  setChartDataIndex(2);
                }}
                className={
                  chartDataIndex === 2 ? styles.filterActive : styles.filter
                }
              >
                1M
              </div>
              <div
                onClick={() => {
                  setChartDataIndex(3);
                }}
                className={
                  chartDataIndex === 3 ? styles.filterActive : styles.filter
                }
              >
                3M
              </div>
              <div
                onClick={() => {
                  setChartDataIndex(0);
                }}
                className={
                  chartDataIndex === 0 ? styles.filterActive : styles.filter
                }
              >
                6M
              </div>
              <div
                onClick={() => {
                  setChartDataIndex(0);
                }}
                className={
                  chartDataIndex === 0 ? styles.filterActive : styles.filter
                }
              >
                1Y
              </div>
            </div>
          </div>
          <div className={styles.bottomSection}>
            <div className={styles.bottomSectionWrapper}>
              <div className={styles.key}>Total</div>
              <div className={styles.value}>$232657931.00258</div>
            </div>
            <div className={styles.bottomSectionWrapper}>
              <div className={styles.key}>Current Value</div>
              <div className={styles.value}>$31,000</div>
            </div>
            <div className={styles.bottomSectionWrapper}>
              <div className={styles.key}>Market Cap (USD)</div>
              <div className={styles.value}>$144.16 B</div>
            </div>
            <div className={styles.bottomSectionWrapper}>
              <div className={styles.key}>Total</div>
              <div className={styles.value}>$14.79 B</div>
            </div>
          </div>
        </>
      )}
      {activeTab === 2 && (
        <>
          {Array.from(Array(10), (e, i) => {
            return (
              <div className={styles.transactions} key={i}>
                <div className={styles.rightWrapper}>
                  <div className={styles.status}>
                    {/* <span>Sent BTC </span> */}
                    Sent BTC{" "}
                    <img
                      src={"/assets/external-link-square-alt.svg"}
                      width="10px"
                      height="10px"
                      alt="Picture of the author"
                    />
                  </div>
                  <div className={styles.time}>April,09,2020,5:42:44 AM</div>
                </div>
                <div className={styles.leftWrapper}>
                  <div className={styles.flexRow}>
                    <div className={styles.value}>0.024</div>
                    <div className={styles.key}>BTC</div>
                  </div>
                  <div className={styles.flexRow}>
                    <div className={styles.value}>0.024</div>
                    <div className={styles.key}>USD</div>
                  </div>
                </div>
              </div>
            );
          })}
        </>
      )}
    </>
  );
};

const changePositive = styles.changePositive;
const changeNegative = styles.changeNegative;

export default PriceChart;
